import styled from 'styled-components';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';

export const StageSelection = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 20px;
    `,
    SelectionButton: styled(CustomBlockButton)`
        width: auto;
        height: auto;
        min-height: 40px;
        padding: 5px 10px;
        background-color: #efefef;
        color: #000;
        border: none;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #e0e0e0;
        }
    `,
    DialogHeader: styled.div`
        padding: 10px;
    `,
    StageList: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
    StageItem: styled.div`
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        flex-direction: column;
        gap: 10px;

        &:hover{
            background: #efefef;
        }

        .uuid{
            font-weight: 600;
        }

        .createdAt{
            font-size: 10px;
            color: #888;
            display: flex;
            justify-content:flex-end;
        }
    `,
}